import React from "react";

const TicketHeaderSkeleton = () => {
  return (
    <div className="flex items-center gap-3 px-3 py-2 bg-dark-50 dark:bg-dark-900 border-b border-dark-200 dark:border-dark-700 min-h-[60px]">
      {/* Avatar skeleton */}
      <div className="w-10 h-10 rounded-full bg-dark-200 dark:bg-dark-700 animate-pulse flex-shrink-0" />

      {/* Text skeleton */}
      <div className="flex-1 min-w-0">
        <div className="h-4 w-28 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-1.5" />
        <div className="h-3 w-36 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
      </div>

      {/* Buttons skeleton */}
      <div className="flex items-center gap-2 ml-auto">
        <div className="h-8 w-20 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
        <div className="h-8 w-20 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
      </div>
    </div>
  );
};

export default TicketHeaderSkeleton;
